export default __webpack_public_path__ + "static/1433-5ef01937bb519df1456bccf5cc2369a9.gif";